import { IHttpApi } from '@cian/http-api/shared';
import { IShowQuizRequest, fetchShowQuiz } from '../../repositories/quiz/v1/show-quiz';

export const getShowQuiz = (httpApi: IHttpApi, parameters: IShowQuizRequest) => fetchShowQuiz({ httpApi, parameters });
